import { render, staticRenderFns } from "./RankChangeConfirm.vue?vue&type=template&id=c79df566&"
import script from "./RankChangeConfirm.vue?vue&type=script&lang=js&"
export * from "./RankChangeConfirm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports